export const PERMISSION_CREATE = `create`;
export const PERMISSION_READ = `read`;
export const PERMISSION_UPDATE = `update`;
export const PERMISSION_DELETE = `delete`;
